import { setContext } from "@apollo/client/link/context";
import { CLIENT_METADATA_HEADER, CLIENT_TYPE, CLIENT_VERSION, SALE_CHANNEL_CODE } from "config/clientMetadata";

/**
 * Gắn client metadata vào mọi request GraphQL để BE biết request đến từ client nào,
 * version nào khi tra log/lỗi.
 *
 * Tách thành file riêng thay vì khai trong apollo.js để test được độc lập — file này chỉ
 * phụ thuộc `setContext` và hằng số config, không kéo theo cả cây import của ApolloClient.
 *
 * Ở module scope, KHÔNG trong `useMemo`: metadata là tĩnh, không phụ thuộc token nên
 * không cần tạo lại link mỗi lần `logoutWithoutApollo` đổi.
 */
export const clientMetadataLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    [CLIENT_METADATA_HEADER.CLIENT_TYPE]: CLIENT_TYPE,
    [CLIENT_METADATA_HEADER.SALE_CHANNEL_CODE]: SALE_CHANNEL_CODE,
    // Chỉ version là có thể thiếu (env do CI cấp). Bỏ hẳn header khi không có, thay vì gửi
    // chuỗi "undefined" — BE phân biệt được "client không gửi" với "client gửi giá trị rác".
    ...(CLIENT_VERSION ? { [CLIENT_METADATA_HEADER.CLIENT_VERSION]: CLIENT_VERSION } : {}),
  },
}));
